import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import ShibLogin from './ShibLoginBase';

export default withCombinedRouteParams(ShibLogin);
